import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LocalStorageService } from 'services';
import { ResourceState } from 'app/resource/types';
import { DirectoryRule } from 'app/resource/types/fileManager';
import { SystemSettings } from 'app/resource/types/systemSettings';
import { CurrenciesPrecisions } from 'app/resource/types/currenciesPrecisions';

const initialState: ResourceState = {
  currenciesPrecisions: LocalStorageService.get('currenciesPrecisions') || {},
  systemSettings: LocalStorageService.get('systemSettings') || {},
  directoryRules: {},
};

const slice = createSlice({
  name: 'resource',
  initialState,
  reducers: {
    saveResourceCurrenciesPrecisions: (state, action: PayloadAction<CurrenciesPrecisions>) => {
      state.currenciesPrecisions = action.payload;
    },
    saveResourceSystemSettings: (state, action: PayloadAction<SystemSettings>) => {
      state.systemSettings = action.payload;
    },
    saveResourceDirectoryRules: (state, action: PayloadAction<Record<string, DirectoryRule[]>>) => {
      state.directoryRules = action.payload;
    },
    resetResourceDirectoryRules: (state) => {
      state.directoryRules = {};
    },
  },
});

export const {
  saveResourceCurrenciesPrecisions, saveResourceSystemSettings, saveResourceDirectoryRules, resetResourceDirectoryRules,
} = slice.actions;

export default slice.reducer;
